import { createStyles, makeStyles } from '@material-ui/core';
import { Colors } from '../../layout/theme-next';

export default makeStyles((theme) =>
  createStyles({
    root: {
      color: Colors.textBlack,
      fontSize: 14,
    },
    editablePreview: {
      minHeight: theme.spacing(10),
      cursor: 'text',
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: Colors.white,
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(1.5),
    },
    marginBStyle: {
      '& p': {
        marginBottom: 0,
      },
      '& p:first-child': {
        marginTop: 0,
      },
    },
    previewContent: {
      width: '100%',
      height: '100%',
    },
    previewPlaceholder: {
      color: Colors.lightGray3,
      padding: theme.spacing(0.5, 0),
    },
  }),
);
